import { sl as reactsl } from '@ews/react-translations';

const sl = {
...reactsl
}
export default sl
